import { Icon } from "@/Common/Components/IconControls/IconControls";
import { Person } from "@/Common/Models/Person/Person";

import styles from "./EmployeeListComponent.module.scss";

interface EmployeeListComponentProps {
    onRemoveEmployeeClick: (userToRemove: Person) => void;
    employees: Person[];
    showDeleteIcons: boolean
    dataCy?: string;
}

function EmployeeListComponent(props: Readonly<EmployeeListComponentProps>): JSX.Element {
    return (
        <div className={styles.employeeList} data-cy={`${props.dataCy}-protect-medical-note-employee-list`}>
            {props.employees
                .sortByProperty(employee => `${employee.LastName}${employee.FirstName}`)
                .map((person: Person) => (
                    <div key={`employee_${person.ContactFacetId}`} data-cy={`${props.dataCy}-employee-${person.ContactFacetId}`}>
                        <span className={styles.employee_item}>{person.prefix} {person.Name} {person.Licence && `(${person.Licence})`}</span>
                        {props.showDeleteIcons && (
                            <button
                                onClick={() => props.onRemoveEmployeeClick(person)}
                                className={styles.deleteIconContainer}
                                data-cy={`${props.dataCy}-remove-employee-${person.ContactFacetId}`}
                            >
                                <Icon
                                    iconHeight="16px"
                                    iconWidth="16px"
                                    type="delete-icon"
                                />
                            </button>
                        )}
                    </div>
                ))}
        </div>
    );
}

export { EmployeeListComponent };
